import React from "react";

const ScrollDownIndicator = (props) => {
  return (
    <svg
      className="scrolldown-indicator"
      viewBox="0 0 100 100"
      width="100"
      height="100"
    >
      <defs>
        <path
          id="circle"
          d="
        M 50, 50
        m -37, 0
        a 37,37 0 1,1 74,0
        a 37,37 0 1,1 -74,0"
        />
      </defs>
      <text className="scrolldown-indicator__text">
        <textPath xlinkHref="#circle">Scroll down · Scroll down ·</textPath>
      </text>
      <svg width="8" height="31" viewBox="0 0 8 31" fill="none" x="46" y="34">
        <path
          d="M4.5 0.541016C4.5 0.264873 4.27614 0.0410156 4 0.0410156C3.72386 0.0410156 3.5 0.264873 3.5 0.541016H4.5ZM3.64645 29.8946C3.84171 30.0898 4.15829 30.0898 4.35355 29.8946L7.53553 26.7126C7.7308 26.5173 7.7308 26.2007 7.53553 26.0055C7.34027 25.8102 7.02369 25.8102 6.82843 26.0055L4 28.8339L1.17157 26.0055C0.976311 25.8102 0.659728 25.8102 0.464466 26.0055C0.269204 26.2007 0.269204 26.5173 0.464466 26.7126L3.64645 29.8946ZM3.5 0.541016L3.5 29.541H4.5L4.5 0.541016H3.5Z"
          fill="black"
        />
      </svg>
    </svg>
  );
};

export default ScrollDownIndicator;
